<script>
  import { colors } from "../../styles/theme"

  export let placeholder
  export let value = ""
</script>

<input
  type="text"
  {placeholder}
  on:keydown
  bind:value
  style={`
    --border-color: ${colors.gray_400};
    --border-hover-color: ${colors.gray_300};
    --placeholder-color: ${colors.gray_400};
  `}
/>

<style>
  input {
    border: 1px solid var(--border-color);
    box-shadow: none;
    cursor: pointer;
    width: 100%;
    border-radius: 4px;
    padding: 12px;
    font-style: italic;
    color: var(--neutral-text-color);
    font-size: 13px;
    cursor: pointer;
    background: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    height: 43px;
    font-size: 13px;
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    color: var(--placeholder-color);
    font-style: italic;
  }

  input:hover {
    border-color: var(--border-hover-color);
    border-width: 2px;
  }
</style>
